import { Injectable } from '@angular/core';
import { LocationService } from '../../../core/services/location.service';
import { NotificationService } from '../../../core/core.module';
import { catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressValidationService {

  stateError = ''
  constructor(
    public locationService: LocationService,
    public notificationSvc: NotificationService,
  ) { }

  lookUpLocationInfoFromZip(
    zipCode: string,
    fromValueChange: boolean = false,
    stateField: any,
    zipField: any,
    formGroup: any,
    agentId: string
  ): Observable<any> {
    return this.locationService.lookupLocationByZip(zipCode, agentId !== '' ? agentId : null).pipe(
      tap(locationInfo => {
        if (locationInfo) {
          if (!fromValueChange) {
            stateField.setValue(locationInfo.stateCode);
          }
          formGroup.updateValueAndValidity();
        } else {
          this.notificationSvc.error(`No licensed locations found for zipcode ${zipCode}.`);
          zipField.setValue(null);
          if (!fromValueChange) {
            stateField.setValue('');
          }
        }
        return of(true);
      }),
      catchError(err => {
        this.notificationSvc.error(`Unable to get location information for ${zipCode}`);
        console.error('Error looking up zipcode info', err);
        zipField.setValue(null);
        stateField.setValue(null);
        return of(true);
      })
    );
  }

  validLocationInfoFromZip(zipCode: string, agentId: string, state: string): Observable<boolean> {
    return this.locationService.lookupLocationByZip(zipCode, agentId !== '' ? agentId : null).pipe(
      map(locationInfo => {
        if (locationInfo) {
          return true;
        } else {
          this.notificationSvc.error(
            `No licensed locations found for zipcode ${zipCode}. Please verify you are licensed in this state.`
          );
          this.stateError = state
          return false;
        }
      }),
      catchError(err => {
        this.notificationSvc.error(`Unable to get location information for ${zipCode}`);
        console.error('Error looking up zipcode info', err);
        return of(false);
      })
    );
  }

  handleNoLicensedStates(noStates: boolean) {
    if (noStates) {
      this.notificationSvc.warn('You do not have any licensed states. Please contact your administrator to set up your state licenses.');
    }
  }
}